import React from 'react'
import "./market-stress-risk-table.scss"
import { useTranslation } from "react-i18next";
import { Table } from 'antd';
import TableNumber from "../../../../../atoms/table-number";

const MarketStressRiskTable = () => {
    const { t } = useTranslation();

    const columns = [
        {
            title: '',
            dataIndex: 'assets',
            key: 'assets',
            width: 280,
            fixed: "left" as const,
            render: (text: any) => {
                let className
                if (text.title === 'Total Assets'
                    || text.title === "Share Holder's Equity"
                    || text.title === 'Total Liabilities'

                ) {
                    className = 'bold-blue'
                }

                else {
                    className = ''
                }

                return <div className='assets' >
                    <div className={className} >
                        {text.title}
                    </div>
                    {text.subTitle &&
                        <div>
                            <ul>
                                <li>{text.subTitle}</li>
                            </ul>
                        </div>
                    }
                </div>
            }
        },
        {
            title: t("AssetLiability.marketValue"),
            children: [
                {
                    title: t("AssetLiability.actual"),
                    dataIndex: 'actual',
                    key: 'actual',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: '+100bp',
                    dataIndex: '100bp1',
                    key: '100bp1',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: '+200bp',
                    dataIndex: '200bp1',
                    key: '200bp1',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: '+400bp',
                    dataIndex: '400bp1',
                    key: '400bp1',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
            ],
        },
        {
            title: "",
            children: [
                {
                    title: '-100bp',
                    dataIndex: '100bp2',
                    key: '100bp2',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: '-200bp',
                    dataIndex: '200bp2',
                    key: '200bp2',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: '-400bp',
                    dataIndex: '400bp2',
                    key: '400bp2',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
            ],
        },
    ];

    let id = 1;
    const data = [
        {
            id: id++,
            "key": 1,
            "assets": {
                "title": "Placements",
                "subTitle": "Due From Banks"
            },
            "actual": "5,572",
            "100bp1": "5,569",
            "200bp1": "5,566",
            "400bp1": "5,566",
            "100bp2": "5,575",
            "200bp2": "5,578",
            "400bp2": "5,578"
        },
        {
            id: id++,
            "key": 2,
            "assets": {
                "title": "",
                "subTitle": "Loan To Banks"
            },
            "actual": "3,357",
            "100bp1": "3,346",
            "200bp1": "3,336",
            "400bp1": "3,342",
            "100bp2": "3,368",
            "200bp2": "3,382",
            "400bp2": "3,390"
        },
        {
            id: id++,
            "key": 3,
            "assets": {
                "title": "",
                "subTitle": "Rev. Repo"
            },
            "actual": "5,217",
            "100bp1": "5,217",
            "200bp1": "5,217",
            "400bp1": "5,217",
            "100bp2": "5,217",
            "200bp2": "5,217",
            "400bp2": "5,217"
        },
        {
            id: id++,
            "key": 4,
            "assets": {
                "title": "Loans",
                "subTitle": "Wholesale Loans"
            },
            "actual": "19,829",
            "100bp1": "19,771",
            "200bp1": "19,720",
            "400bp1": "19,745",
            "100bp2": "19,924",
            "200bp2": "20,188",
            "400bp2": "21,336"
        },
        {
            id: id++,
            "key": 5,
            "assets": {
                "title": "",
                "subTitle": "Commercial Loans"
            },
            "actual": "72,080",
            "100bp1": "71,497",
            "200bp1": "70,936",
            "400bp1": "70,044",
            "100bp2": "72,688",
            "200bp2": "73,345",
            "400bp2": "74,536"
        },
        {
            id: id++,
            "key": 6,
            "assets": {
                "title": "",
                "subTitle": "Consumer Loans"
            },
            "actual": "25,758",
            "100bp1": "25,266",
            "200bp1": "24,787",
            "400bp1": "23,916",
            "100bp2": "26,264",
            "200bp2": "26,784",
            "400bp2": "27,818"
        },
        {
            id: id++,
            "key": 7,
            "assets": {
                "title": "",
                "subTitle": "Mortgage Finance"
            },
            "actual": "10,811",
            "100bp1": "10,688",
            "200bp1": "10,575",
            "400bp1": "10,434",
            "100bp2": "10,946",
            "200bp2": "11,185",
            "400bp2": "11,926"
        },
        {
            id: id++,
            "key": 8,
            "assets": {
                "title": "",
                "subTitle": "Credit Cards"
            },
            "actual": "1,505",
            "100bp1": "1,480",
            "200bp1": "1,456",
            "400bp1": "1,411",
            "100bp2": "1,530",
            "200bp2": "1,556",
            "400bp2": "1,606"
        },
        {
            id: id++,
            "key": 9,
            "assets": {
                "title": "",
                "subTitle": "Overdrafts"
            },
            "actual": "9,119",
            "100bp1": "9,062",
            "200bp1": "9,005",
            "400bp1": "8,916",
            "100bp2": "9,177",
            "200bp2": "9,236",
            "400bp2": "9,334"
        },
        {
            id: id++,
            "key": 10,
            "assets": {
                "title": "Investments",
                "subTitle": "T-Bills"
            },
            "actual": "18,967",
            "100bp1": "18,867",
            "200bp1": "18,769",
            "400bp1": "18,707",
            "100bp2": "19,066",
            "200bp2": "19,167",
            "400bp2": "19,232"
        },
        {
            id: id++,
            "key": 11,
            "assets": {
                "title": "",
                "subTitle": "Bonds"
            },
            "actual": "8,297",
            "100bp1": "8,004",
            "200bp1": "7,729",
            "400bp1": "7,234",
            "100bp2": "8,609",
            "200bp2": "8,940",
            "400bp2": "9,659"
        },
        {
            id: id++,
            "key": 12,
            "assets": {
                "title": "",
                "subTitle": "Corporate Bonds"
            },
            "actual": "0",
            "100bp1": "0",
            "200bp1": "0",
            "400bp1": "0",
            "100bp2": "0",
            "200bp2": "0",
            "400bp2": "0"
        },
        {
            id: id++,
            "key": 13,
            "assets": {
                "title": "",
                "subTitle": "Floating Rate Notes"
            },
            "actual": "4,571",
            "100bp1": "4,563",
            "200bp1": "4,554",
            "400bp1": "4,562",
            "100bp2": "4,583",
            "200bp2": "4,660",
            "400bp2": "4,925"
        },
        {
            id: id++,
            "key": 14,
            "assets": {
                "title": "",
                "subTitle": "Core Portfolio"
            },
            "actual": "2,384",
            "100bp1": "2,338",
            "200bp1": "2,294",
            "400bp1": "2,218",
            "100bp2": "2,432",
            "200bp2": "2,483",
            "400bp2": "2,589"
        },
        {
            id: id++,
            "key": 15,
            "assets": {
                "title": "",
                "subTitle": "Grade Portfolio"
            },
            "actual": "5,585",
            "100bp1": "5,193",
            "200bp1": "4,850",
            "400bp1": "4,284",
            "100bp2": "6,040",
            "200bp2": "6,572",
            "400bp2": "7,963"
        },
        {
            id: id++,
            "key": 16,
            "assets": {
                "title": "",
                "subTitle": "CDs and BA's"
            },
            "actual": "633",
            "100bp1": "632",
            "200bp1": "630",
            "400bp1": "632",
            "100bp2": "634",
            "200bp2": "635",
            "400bp2": "634"
        },
        {
            id: id++,
            "key": 17,
            "assets": {
                "title": "Risk Sensitive Assets"
            },
            "actual": "193,686",
            "100bp1": "191,492",
            "200bp1": "189,423",
            "400bp1": "186,227",
            "100bp2": "201,036",
            "200bp2": "204,084",
            "400bp2": "211,295"
        },
        {
            id: id++,
            "key": 18,
            "assets": {
                "title": "Total Assets"
            },
            "actual": "193,686",
            "100bp1": "191,492",
            "200bp1": "189,423",
            "400bp1": "186,227",
            "100bp2": "201,036",
            "200bp2": "204,084",
            "400bp2": "211,295"
        }
    ];

    const liabilitiesData = [
        {
            id: id++,
            "key": 1,
            "assets": {
                "title": "Deposits",
                "subTitle": "Fixed Deposits"
            },
            "actual": "(84,542)",
            "100bp1": "(84,335)",
            "200bp1": "(84,129)",
            "400bp1": "(84,064)",
            "100bp2": "(84,750)",
            "200bp2": "(84,960)",
            "400bp2": "(85,033)"
        },
        {
            id: id++,
            "key": 2,
            "assets": {
                "title": "",
                "subTitle": "Call - Notice"
            },
            "actual": "(71)",
            "100bp1": "(71)",
            "200bp1": "(71)",
            "400bp1": "(71)",
            "100bp2": "(71)",
            "200bp2": "(71)",
            "400bp2": "(71)"
        },
        {
            id: id++,
            "key": 3,
            "assets": {
                "title": "",
                "subTitle": "Customer Repos"
            },
            "actual": "(589)",
            "100bp1": "(589)",
            "200bp1": "(589)",
            "400bp1": "(589)",
            "100bp2": "(589)",
            "200bp2": "(589)",
            "400bp2": "(589)"
        },
        {
            id: id++,
            "key": 4,
            "assets": {
                "title": "",
                "subTitle": "Savings"
            },
            "actual": "(361)",
            "100bp1": "(361)",
            "200bp1": "(360)",
            "400bp1": "(361)",
            "100bp2": "(361)",
            "200bp2": "(362)",
            "400bp2": "(361)"
        },
        {
            id: id++,
            "key": 5,
            "assets": {
                "title": "Borrowings",
                "subTitle": "Due To banks"
            },
            "actual": "(4,854)",
            "100bp1": "(4,846)",
            "200bp1": "(4,838)",
            "400bp1": "(4,844)",
            "100bp2": "(4,861)",
            "200bp2": "(4,869)",
            "400bp2": "(4,863)"
        },
        {
            id: id++,
            "key": 6,
            "assets": {
                "title": "",
                "subTitle": "Sama Repos"
            },
            "actual": "",
            "100bp1": "",
            "200bp1": "",
            "400bp1": "",
            "100bp2": "",
            "200bp2": "",
            "400bp2": ""
        },
        {
            id: id++,
            "key": 7,
            "assets": {
                "title": "",
                "subTitle": "Banks Repos"
            },
            "actual": "",
            "100bp1": "",
            "200bp1": "",
            "400bp1": "",
            "100bp2": "",
            "200bp2": "",
            "400bp2": ""
        },
        {
            id: id++,
            "key": 8,
            "assets": {
                "title": "Debt Security",
                "subTitle": ""
            },
            "actual": "(4,167)",
            "100bp1": "(4,154)",
            "200bp1": "(4,142)",
            "400bp1": "(4,133)",
            "100bp2": "(4,181)",
            "200bp2": "(4,259)",
            "400bp2": "(4,548)"
        },
        {
            id: id++,
            "key": 9,
            "assets": {
                "title": "Risk Sensitive Liabilities",
                "subTitle": ""
            },
            "actual": "(94,583)",
            "100bp1": "(94,355)",
            "200bp1": "(94,129)",
            "400bp1": "(94,062)",
            "100bp2": "(94,813)",
            "200bp2": "(95,110)",
            "400bp2": "(95,465)"
        },
        {
            id: id++,
            "key": 10,
            "assets": {
                "title": "Deposits - NIB",
                "subTitle": ""
            },
            "actual": "(63,486)",
            "100bp1": "(63,486)",
            "200bp1": "(63,486)",
            "400bp1": "(63,486)",
            "100bp2": "(63,486)",
            "200bp2": "(63,486)",
            "400bp2": "(63,486)"
        },
        {
            id: id++,
            "key": 11,
            "assets": {
                "title": "Total Liabilities",
                "subTitle": ""
            },
            "actual": "(158,069)",
            "100bp1": "(157,841)",
            "200bp1": "(157,614)",
            "400bp1": "(157,548)",
            "100bp2": "(158,299)",
            "200bp2": "(158,595)",
            "400bp2": "(158,951)"
        },
        {
            id: id++,
            "key": 12,
            "assets": {
                "title": "Share Holder's Equity",
                "subTitle": ""
            },
            "actual": "(35,616)",
            "100bp1": "(33,651)",
            "200bp1": "(31,809)",
            "400bp1": "(28,680)",
            "100bp2": "(42,736)",
            "200bp2": "(45,488)",
            "400bp2": "(52,344)"
        }
    ];

    const marketValueRiskData = [
        {
            id: id++,
            "key": 1,
            "assets": {
                "title": "Market Value at Risk",
                "subTitle": ""
            },
            "actual": "",
            "100bp1": "(1,965)",
            "200bp1": "(3,808)",
            "400bp1": "(6,936)",
            "100bp2": "2,296",
            "200bp2": "5,048",
            "400bp2": "11,904"
        }
    ];

    return (
        <div className='market-stress-risk-table-wrapper' >
            <div className='market-stress-table'>
                <div className="market-stress-table__heading">{t("AssetLiability.marketRiskComparison")}</div>
                <div className="market-stress-table__date">05/31/2024 CAD {t("AssetLiability.inMillions")}</div>
                <div className="market-stress-table__table" >
                    <Table
                        columns={columns}
                        dataSource={data}
                        bordered
                        scroll={{ x: 900 }}
                        pagination={false}
                        rowClassName={(record, index) => {

                            if (record.key === 17) {
                                return 'market-stress-table__orange';
                            }
                            else if (record.key === 18) {
                                return 'market-stress-table__bold-blue';
                            }
                            else if (index % 2 === 0) {
                                return 'market-stress-table__table__white';
                            }
                            else {
                                return 'market-stress-table__light-blue';
                            }
                        }}
                        rowKey="id"
                    />
                </div>

                <div className="market-stress-table__table liabilities" >
                    <Table
                        columns={columns}
                        dataSource={liabilitiesData}
                        bordered
                        scroll={{ x: 900 }}
                        pagination={false}
                        rowClassName={(record, index) => {
                            if (record.key === 9) {
                                return 'market-stress-table__orange';
                            }
                            else if (index % 2 === 0 || record.key === 11 || record.key === 12) {
                                return ' market-stress-table__light-blue';
                            }
                            else {
                                return 'market-stress-table__table__white';
                            }
                        }}
                        rowKey="id"
                    />
                </div>

                <div className="market-stress-table__table total-liabilities" >
                    <Table
                        columns={columns}
                        dataSource={marketValueRiskData}
                        bordered
                        scroll={{ x: 900 }}
                        pagination={false}
                        rowClassName='market-stress-table__yellow'
                        rowKey="id"
                    />
                </div>
            </div>
        </div>
    )
}

export default MarketStressRiskTable
